import React from 'react';
import { Tabs } from '@material-ui/core';
import Tab from '@material-ui/core/Tab';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import DeleteIcon from '@material-ui/icons/Delete';
import { BLOCK_TYPES } from '../../lib/constants';
import { useDispatch, useShallowSelector } from '../../lib/reduxHooks';
import type { IRootState } from '../../store';
import * as actions from '../../store/senderBuild/actions';
import type { IBlock, IBlocks, ISelectedBlocks } from '../../store/senderBuild/types';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const selector = (state: IRootState) => ({
  selectedBlock: state.senderBuild.selectedBlocks,
  blocks: state.senderBuild.blocks,
});

interface IState {
  selectedBlock: ISelectedBlocks;
  blocks: IBlocks;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const MobileBlockSettings = () => {
  const dispatch = useDispatch();
  const { selectedBlock, blocks }: IState = useShallowSelector(selector);
  const block: IBlock = blocks[selectedBlock.documentId!][selectedBlock.pageIndex!][selectedBlock.blockIndices[0]];
  if (!block) return null;

  const currentBlockType = BLOCK_TYPES.find((bt) => bt.key === block.blockType);

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const handleBlockClick = (type: string) => {
    let update: any = {};

    if (type === 'Optional') {
      update.required = !block.required;
      dispatch(
        actions.editBlock(selectedBlock.documentId!, selectedBlock.pageIndex!, selectedBlock.blockIndices[0], update)
      );
    }
    if (type === 'Read Only') {
      update.assignedTo = block.assignedTo ? null : block.previouslyAssignedTo;
      if (update.assignedTo === null) {
        update.readOnly = true;
        update.previouslyAssignedTo = block.assignedTo;
      } else {
        update.readOnly = false;
      }

      update.required = false;

      dispatch(
        actions.editBlock(selectedBlock.documentId!, selectedBlock.pageIndex!, selectedBlock.blockIndices[0], update)
      );
    }
    if (type === 'Delete') {
      dispatch(actions.deleteBlocks(selectedBlock.documentId!, selectedBlock.pageIndex!, [block.blockId!]));
      dispatch(actions.changeActiveBlockType(''));
    }
  };

  return (
    <div
      className="w-full"
      style={{ borderBottom: '1px solid #CAD5E0', height: '79px' }}
      data-spec="mobileBlockSettings"
    >
      <Tabs className="h-full" classes={{ flexContainer: 'h-full justify-center' }}>
        {currentBlockType!.mobileOptions!.map((option: string, index: number) => {
          let icon;
          if ((option === 'Read Only' && !block.readOnly) || (option === 'Optional' && block.required)) {
            icon = <CheckBoxOutlineBlankIcon />;
          } else if ((option === 'Read Only' && block.readOnly) || (option === 'Optional' && !block.required)) {
            icon = <CheckBoxIcon />;
          } else if (option === 'Delete') {
            icon = <DeleteIcon />;
          }
          return (
            <Tab
              key={index}
              onClick={() => handleBlockClick(option)}
              label={option}
              value={option}
              className={'text-blue-800 flex-1 opacity-100'}
              icon={icon}
              data-spec={`setting-${option}`}
              classes={{ wrapper: 'capitalize' }}
            />
          );
        })}
      </Tabs>
    </div>
  );
};
// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default MobileBlockSettings;
